import useStore from "../../../store"
import PendingTransfers from "./PendingTransfers"
import ProcessingTransfers from "./ProcessingTransfers"
import PastTxns from "./PastTxns"

export default function TransferHistoryBody({ handleClick = null }) {
  const pendingTransfers = useStore((state) => state.pendingTransfers)
  const processingTransfers = useStore((state) => state.processingTransfers)

  return (
    <>
        {pendingTransfers?.length > 0 && <PendingTransfers />}
        {processingTransfers?.length > 0 && <ProcessingTransfers handleClick={handleClick} />}
        <PastTxns handleClick={handleClick} />
    </>
  )
}